<template>
    <div class="my-10">
        <div class="flex justify-between mb-5">
            <h1 class="text-2xl font-bold">
                {{ $t('nav.businessAccounts') }}
            </h1>
            <div class="flex gap-5 items-center">
                <button @click="toggleFilter(true)" class="hidden gap-2 items-center text-main-color bg-white p-2 rounded-lg max-lg:flex"><IconFilter/><p>{{ $t('page.filter') }}</p></button>
                <div class="">
  <a
    v-if="store.catalog?.file"
    :href="store.catalog.file"
    download
    @click="store.downloadCatalog()"
    class="relative ml-auto w-max bg-white text-main-color flex items-center justify-center rounded-lg gap-1 px-4 py-2 hover:bg-accent-color hover:text-white"
  >
    {{ $t('page.catalog') }}
    <span class="text-sm">({{ store.catalog?.download_count || 0 }})</span>
    <IconDownload class="[&>path]:fill-main-color" />
    <span
      v-if="store.catalog?.has_catalog"
      class="w-5 h-5 bg-red-500 absolute -top-2 -left-2 rounded-full"
    />
  </a>

  <span
    v-else
    class="relative ml-auto w-max bg-white/60 text-main-color flex items-center justify-center rounded-lg gap-1 px-4 py-2"
  >
    {{ $t('page.catalog') }}
    <span class="text-sm">(0)</span>
  </span>
</div>
            </div>
        </div>
        <div class="grid grid-cols-4 gap-5">
            <div class="col-span-1">
                <MediaSide 
                @closeFilter="toggleFilter(false)"
                :filterState="filterState"
                :categories="store?.accountCategories" 
                routeName="businessAccounts" 
                :currentCategory="currentCategory" 
                :currentSubscription="currentSubscription" 
                :location="locationId"
                :isVip="isVip"></MediaSide>
            </div>
            <div class="col-span-3 max-lg:col-span-4">
              
                <div class="grid grid-cols-3 max-lg:grid-cols-2 gap-4">
                    <template v-for="item in accounts" :key="item.id">
                        <router-link :to="{ name: 'businessAccountsDetail', params: { id: item.id } }">
                            <BusinessAccountCard :detail="item">
                            </BusinessAccountCard>
                        </router-link>
                    </template>
                    
                </div>
                <div v-show="accounts.length === 0 && loading === false">
                    <p class="text-xl font-medium whitespace-nowrap">{{ $t('page.not_found') }}</p>
                </div>
                <div v-show="loading === true" class="flex justify-center mt-10" role="status">
                    <IconSpinner class="w-12 h-12 mr-2 text-gray-200 animate-spin  fill-main-color">
                    </IconSpinner>

                    <span class="sr-only">Loading...</span>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
import IconSpinner from '@icons/IconSpinner.vue';
import IconDownload from '@icons/IconDownload.vue';
import IconFilter from '@icons/IconFilter.vue';
import PublicationCard from '@cmp/publication/PublicationCard.vue'
import api from '@/api';
import BusinessAccountCard from '@cmp/media/BusinessAccountCard.vue'
import MediaSide from '@cmp/media/MediaSide.vue'
import { updateLastSeen } from '@/helpers'
import { useAppStore } from '@/store'
export default {
    name: 'businessAccounts',
    components: {
        PublicationCard,
        IconSpinner,
        IconDownload,
        BusinessAccountCard,
        MediaSide,
        IconFilter
    },
    watch: {
  // ✅ 1) СМЕНА ЛОКАЦИИ — полный сброс + каталог + первая страница
      locationId: {
        immediate: true,
        async handler(newVal, oldVal) {
        if (!newVal) return;

        const reqId = (this._reqId = (this._reqId || 0) + 1);

        // 🔥 сброс списка
        this.page = 1;
        this.accounts = [];
        this.next = null;
        this.count = 0;

        // 🔥 гасим кружок сразу
        this.store.catalog = {
          ...(this.store.catalog || {}),
          has_catalog: false,
          isNew: false,
          file: null,
          download_count: 0,
        };

        try {
          await this.getCatalog(newVal, reqId);
          if (reqId !== this._reqId) return;

          await this.getAccounts(reqId); // getAccounts должен использовать this.locationId
        } catch (e) {
          console.log(e);
        }
      },
    },

  // ✅ 2) СМЕНА CATEGORY — сброс page + перезагрузка
    '$route.query.category': {
      async handler(newValue, oldValue) {
        if (newValue === oldValue) return;

        const reqId = (this._reqId = (this._reqId || 0) + 1);

        this.currentCategory = newValue;

        this.page = 1;
        this.accounts = [];
        this.next = null;
        this.count = 0;

        await this.getAccounts(reqId);
        
      },
    },

  // ✅ 3) СМЕНА SUBSCRIPTION — сброс page + перезагрузка
    '$route.query.subscription': {
      async handler(newValue, oldValue) {
       if (newValue === oldValue) return;

       const reqId = (this._reqId = (this._reqId || 0) + 1);

       this.currentSubscription = newValue;

       this.page = 1;
       this.accounts = [];
       this.next = null;
       this.count = 0;

       await this.getAccounts(reqId);
      },
    },

  // ✅ 4) СМЕНА VIP — сброс page + перезагрузка
   '$route.query.is_vip': {
      async handler(newValue, oldValue) {
        if (newValue === oldValue) return;

        const reqId = (this._reqId = (this._reqId || 0) + 1);

        this.isVip = newValue;

        this.page = 1;
        this.accounts = [];
        this.next = null;
        this.count = 0;

       await this.getAccounts(reqId);
       },
    },
  },
    data() {
        return {
            _reqId: 0,
            loading: false,
            accounts: [],
            categories: [],
            currentCategory: null,
            currentSubscription: null,
            isVip: null,
            page: 1,
            count: 0,
            next: null,
            catalog: undefined,
			store: useAppStore(),
            isNew: false,
            filterState: false

        }
    },
    methods: {
        toggleFilter(e){
            this.filterState = e
            document.body.style.overflowY = e ? 'hidden' : 'initial'
        },
        infiniteScroll() {
            let scrollTop = document.documentElement.scrollTop
            let scrollHeight = document.documentElement.scrollHeight
            let clientHeight = document.documentElement.clientHeight
            if (scrollTop + clientHeight >= scrollHeight - 650) {
                if (this.next !== null && this.loading === false) {
                    this.page += 1;
                    this.getAccounts(this._reqId);
                }
            }
        },
        async getAccounts(reqId = this._reqId) {
          this.loading = true;
          try {
            const response = await api.get('posts/business_accounts/', {
              params: {
                category: this.currentCategory,
                page: this.page,
                subscription: this.currentSubscription,
                is_vip: this.vipParam,      // ✅
                location: this.locationId,
          },
        });

        if (reqId !== this._reqId) return;

        const results = response.data.results || [];

        // ✅ если page=1 — подстрахуемся от дублей
        if (this.page === 1) this.accounts = results;
        else this.accounts.push(...results);

        this.count = response.data.count;
        this.next = response.data.next;
      } catch (e) {
        console.log(e);
      } finally {
        if (reqId === this._reqId) this.loading = false;
      }
    },
        async getCatalog(locationId, reqId = this._reqId) {
          try {
            const r = await api.get(`posts/catalogs/${locationId}/`);
            if (reqId !== this._reqId) return;

            const hasCatalog = !!r.data?.has_catalog;

            this.store.catalog = {
              ...(this.store.catalog || {}),
              has_catalog: hasCatalog,
              file: r.data?.file ?? null,
              download_count: r.data?.download_count ?? 0,
              isNew: hasCatalog,
            };
            } catch (e) {
                if (reqId !== this._reqId) return;

                this.store.catalog = {
                  ...(this.store.catalog || {}),
                  has_catalog: false,
                  isNew: false,
                  file: null,
                  download_count: 0,
                };
            }
      },


       
    },
    computed: {
        locationId() {
          return this.store?.selectedLocation?.id
            ?? (JSON.parse(localStorage.getItem('selectedLocation'))?.id ?? 1);
        },
    
        vipParam() {
          const v = this.isVip;
          if (v === undefined || v === null || v === '') return null;
          if (v === true || v === 'true' || v === '1' || v === 1) return true;
          if (v === false || v === 'false' || v === '0' || v === 0) return false;
          return null;
        },
      },

    mounted() {
        window.addEventListener("scroll", this.infiniteScroll)
    },
    unmounted() {
      window.removeEventListener("scroll", this.infiniteScroll);
      document.body.style.overflowY = 'initial';
    },
    async created() {
      this.currentCategory = this.$route.query.category;
      this.currentSubscription = this.$route.query.subscription;
      this.isVip = this.$route.query.is_vip;
      


    }
}

</script>

<style scoped></style>
